(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-description"] && !Shopify.designMode) return;
  try {
    class CollapsibleDescription extends HTMLElement {
    connectedCallback() {
      this.content = this.querySelector('.collapsible-description__content');
      this.toggle = this.querySelector('.collapsible-description__toggle');
      this.toggle?.addEventListener('click', () => this.toggleDescription());
      requestAnimationFrame(() => this.updateOverflow());
    }

    updateOverflow() {
      if (!this.content || !this.toggle) return;
      const collapsedHeight = Number.parseFloat(getComputedStyle(this).getPropertyValue('--collapsed-description-height'));
      const hasOverflow = this.content.scrollHeight > collapsedHeight + 1;
      this.style.setProperty('--expanded-description-height', `${this.content.scrollHeight}px`);
      this.toggle.hidden = !hasOverflow;
      this.toggleAttribute('data-overflow', hasOverflow);
      this.toggleAttribute('data-short', !hasOverflow);
    }

    toggleDescription() {
      this.style.setProperty('--expanded-description-height', `${this.content.scrollHeight}px`);
      const expanded = this.toggleAttribute('data-expanded');
      this.toggle.setAttribute('aria-expanded', String(expanded));
      this.toggle.textContent = expanded ? this.toggle.dataset.hideLabel : this.toggle.dataset.showLabel;
    }
  }

  if (!customElements.get('collapsible-description')) {
    customElements.define('collapsible-description', CollapsibleDescription);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["replacement-guarantee"] && !Shopify.designMode) return;
  try {
    class ReplacementGuarantee extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.querySelector('.replacement-guarantee__info')?.addEventListener('click', () => this.dialog?.showModal());
      this.querySelector('.replacement-guarantee__close')?.addEventListener('click', () => this.dialog?.close());
      this.dialog?.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.dialog.close();
      });
    }
  }

  if (!customElements.get('replacement-guarantee')) {
    customElements.define('replacement-guarantee', ReplacementGuarantee);
  }
  } catch(e) { console.error(e); }
})();

})();
